import { useNavigate } from "react-router-dom";
import { Subtree, useSubtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { onboardingPath } from "../../core/primitives/onboarding";
import { ShellActions } from "../../shell/shell-model";
import { OnboardingSellingController } from "./onboarding-selling-controller";
import { OnboardingSellingPage } from "./onboarding-selling-page";

export function OnboardingSellingRoute({ deps }: { deps: AppDeps }) {
  const navigate = useNavigate();
  const shell = useSubtree(ShellActions);
  const answered = (step: "show" | "locations", storeId: string) => {
    shell.onboardingAnswered();
    navigate(onboardingPath(step, storeId));
  };
  return (
    <Subtree
      key="onboarding-selling"
      controller={() =>
        new OnboardingSellingController(pick(deps, "storeRepository"), {
          toShop: (storeId) => navigate(onboardingPath("shop", storeId)),
          toShow: (storeId) => answered("show", storeId),
          toLocations: (storeId) => answered("locations", storeId),
        })
      }
    >
      <OnboardingSellingPage />
    </Subtree>
  );
}
